import { useState } from "react";
import { Card, Table, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { api, AuditLog } from "../api";

const { Text } = Typography;

export default function Audit() {
  const [page, setPage] = useState(1);
  const pageSize = 50;

  const { data, isLoading } = useQuery({
    queryKey: ["audit", page],
    queryFn: async () =>
      (await api.get<{ items: AuditLog[] }>("/audit", { params: { limit: pageSize, offset: (page - 1) * pageSize } })).data,
    refetchInterval: 60_000,
  });

  return (
    <Card style={{ background: "#10131A", border: "1px solid #1A1D26" }} title={<span style={{ color: "#F5F5F7" }}>操作审计</span>}>
      <Table<AuditLog>
        rowKey="id"
        loading={isLoading}
        dataSource={data?.items}
        pagination={{ current: page, pageSize, total: data?.items?.length === pageSize ? page * pageSize + 1 : (page - 1) * pageSize + (data?.items?.length ?? 0), onChange: setPage, showSizeChanger: false }}
        columns={[
          { title: "时间", dataIndex: "created_at", width: 170, render: (v) => new Date(v).toLocaleString() },
          { title: "操作员", dataIndex: "actor_role", width: 120, render: (role, r) => (<span><Tag>{role ?? "system"}</Tag>{r.actor_id && <Text style={{ color: "#6B7280", fontFamily: "JetBrains Mono", fontSize: 11 }}>{r.actor_id.slice(0, 8)}</Text>}</span>) },
          { title: "动作", dataIndex: "action", width: 180, render: (v: string) => <Tag color="purple">{v}</Tag> },
          { title: "目标", dataIndex: "target", width: 220, render: (v) => v && <span style={{ fontFamily: "JetBrains Mono", fontSize: 11 }}>{String(v).slice(0, 24)}{String(v).length > 24 ? "…" : ""}</span> },
          { title: "Payload", dataIndex: "payload", render: (v) => v ? <pre style={{ margin: 0, fontSize: 11, maxHeight: 80, overflow: "auto", color: "#A1A1AA" }}>{JSON.stringify(v)}</pre> : null },
          { title: "IP", dataIndex: "ip", width: 130 },
        ]}
      />
    </Card>
  );
}
